export default __webpack_public_path__ + "static/media/eth.1608a8a8.png";